import * as React from "react";
import ToolTip from "@components/layout/tool-tip";
// assets
import IconTriangle from "@assets/icons/IconTriangle";
import { teal } from "@styles/synchrony-core-palette.js";
import type { TableHeaderProps } from "./types";

const TableHeader = <T,>({
  onColumnLabelClick,
  tableConfig,
  formerSortProperty,
  sortReverse,
  customStyle,
}: TableHeaderProps<T>): React.ReactElement => {
  // Derived directly from tableConfig — no useState/useEffect mirroring needed.
  const localColumns = [
    ...(tableConfig.columns ?? []),
    ...(tableConfig.innerColumns ?? []),
  ];

  return (
    <div
      id="syf-table-header-container"
      className={`syf-table-header-container subhead-md max-w-full py-0 px-6 ${customStyle ?? ""}`}
    >
      {localColumns.map((column, index) => {
        const toolTipDetails = column.toolTip;
        return !column.displayIfKeyExists ? (
          <div
            key={`table-header-${column.name}-${index}`}
            className={`syf-table-header-cell ${column.headerClassName ? column.headerClassName : ""
              } ${column.width ?? ""} ${column.sortKey ? "cursor-pointer" : "cursor-default"} ${column.customLabelStyle ? column.customLabelStyle : ""}`.trim()}
          >
            {column.sortKey ? (
              <div
                className={`syf-sort-header-icon ${formerSortProperty === column.sortKey
                  ? "subhead-bold"
                  : "subhead-md"
                  }`}
                data-testid={column.dataTestId}
                onClick={() => onColumnLabelClick(column.sortKey as string)}
              >
                {!column.hideColumnLabel && column.name}{" "}
                {formerSortProperty === column.sortKey ? (
                  <IconTriangle
                    iconFillColor={teal}
                    className={`ml-[3px] ${sortReverse ? "rotate-180" : "rotate-0"
                      }`}
                  />
                ) : null}
              </div>
            ) : (
              !column.hideColumnLabel && column.name
            )}
            {toolTipDetails && Object.prototype.hasOwnProperty.call(toolTipDetails, "textContent") ? (
              <div
                className={`syf-header-tool-tip ${toolTipDetails.toolTipContainerConfig ?? ""}`}
              >
                <ToolTip
                  messageText={toolTipDetails.textContent}
                  iconContainerStyle={`relative top-[-15px] ${toolTipDetails.toolTipConfig
                    ? toolTipDetails.toolTipConfig.toolTipIconStyle
                    : ""
                    }`}
                  toolTipPopupStyle={
                    toolTipDetails.toolTipConfig &&
                      toolTipDetails.toolTipConfig.popupStyle
                      ? toolTipDetails.toolTipConfig.popupStyle
                      : ""
                  }
                  place="right"
                  toolTipId={
                    toolTipDetails.toolTipConfig &&
                    toolTipDetails.toolTipConfig.id
                  }
                />
              </div>
            ) : (
              " "
            )}
          </div>
        ) : null;
      })}
    </div>
  );
};

export default TableHeader;
